/**
 * Сервис для работы с предложениями статей расходов
 */

import api from './api';

export interface ExpenseSuggestions {
  suggestions: string[];
  count: number;
}

export interface SuggestionsStatus {
  file_count: number;
  sheets_count: number;
  is_up_to_date: boolean;
  last_update: string;
}

class SuggestService {
  /**
   * Получает предложения статей расходов
   */
  async getExpenseSuggestions(restaurantId?: string): Promise<ExpenseSuggestions> {
    if (!restaurantId) {
      // Возвращаем пустой список если ресторан не выбран
      return { suggestions: [], count: 0 };
    }
    return await api.get(`/suggest/expenses?restaurant_id=${restaurantId}`);
  }

  /**
   * Принудительно обновляет предложения статей расходов
   */
  async updateExpenseSuggestions(): Promise<{ status: string; message: string }> {
    return await api.post('/suggest/expenses/update');
  }

  /**
   * Получает статус кэша предложений
   */
  async getSuggestionsStatus(): Promise<SuggestionsStatus> {
    return await api.get('/suggest/expenses/status');
  }
}

export default new SuggestService();
